<template>
  <div class="card mb-4">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="card-title mb-0">Client</h5>
      <button class="btn btn-sm btn-primary" @click="openModal">
        <i class="fe fe-user-plus me-1"></i> Ajouter/Sélectionner
      </button>
    </div>

    <div class="card-body">
      <div v-if="selectedClient">
        <p class="fw-bold mb-1">{{ selectedClient.firstname }} {{ selectedClient.lastname }}</p>
        <p class="text-muted small mb-0">{{ selectedClient.email }}</p>
        <p class="text-muted small">{{ selectedClient.address?.city || 'Adresse non définie' }}</p>
      </div>
      <div v-else class="text-muted">
        Aucun client sélectionné.
      </div>
    </div>

    <!-- Modal de sélection/ajout -->
    <div class="modal fade" id="customerModal" tabindex="-1" role="dialog" ref="modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Sélectionner un client</h5>
            <button type="button" class="btn-close" @click="closeModal"></button>
          </div>
          <div class="modal-body">
            <div v-if="clients.length === 0" class="text-center text-muted">Chargement des clients...</div>
            <ul class="list-group">
              <li
                  v-for="client in clients"
                  :key="client.id"
                  class="list-group-item d-flex justify-content-between align-items-center"
              >
                <div>
                  <strong>{{ client.firstname }} {{ client.lastname }}</strong><br />
                  <small>{{ client.email }}</small>
                </div>
                <button class="btn btn-sm btn-success" @click="selectClient(client)">Choisir</button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CustomerSelector",
    props: {
      selectedClient: Object
    },
    data() {
      return {
        clients: []
      };
    },
    methods: {
      openModal() {
        this.loadClients();
        $(this.$refs.modal).modal('show');
      },
      closeModal() {
        $(this.$refs.modal).modal('hide');
      },
      selectClient(client) {
        this.$emit('select-customer', client);
        this.closeModal();
      },
      loadClients() {
        this.$http.get("/clients")
            .then(({ data }) => {
              this.clients = data;
            })
            .catch(err => {
              console.error("Erreur lors du chargement des clients :", err);
            });
      }
    }
  };
</script>

<style scoped>
.modal-body {
  max-height: 400px;
  overflow-y: auto;
}
</style>
